<template>
  <section class="bg-white border border-slate-100 rounded-2xl shadow-sm p-6">
    <div class="flex items-center gap-2 mb-5">
      <div class="w-7 h-7 bg-emerald-50 rounded-lg flex items-center justify-center">
        <svg class="w-4 h-4 text-emerald-600" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
        </svg>
      </div>
      <h2 class="text-base font-bold text-slate-800">Add Favourite Location</h2>
    </div>

    <form @submit.prevent="addLocation" class="space-y-4">
      <div>
        <label class="field-label">Label</label>
        <input v-model="form.label" class="field-input" placeholder="e.g. Home, Work, Airport" required/>
      </div>

      <div>
        <label class="field-label">Address</label>
        <input v-model="form.address" class="field-input" placeholder="Street address" required/>
      </div>

      <div class="grid grid-cols-2 gap-3">
        <div>
          <label class="field-label">City</label>
          <input v-model="form.city" class="field-input" placeholder="City" required/>
        </div>
        <div>
          <label class="field-label">Country</label>
          <input v-model="form.country" class="field-input" placeholder="Country" required/>
        </div>
      </div>

      <AlertBanner :message="message" type="success" />
      <AlertBanner :message="error" type="error" />

      <button
        type="submit"
        :disabled="loading"
        class="w-full bg-emerald-600 text-white py-2.5 rounded-xl text-sm font-semibold hover:bg-emerald-700 transition-colors disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
      >
        <svg v-if="loading" class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
        </svg>
        {{ loading ? 'Saving…' : 'Add Location' }}
      </button>
    </form>
  </section>
</template>

<script>
import AlertBanner from "@/components/AlertBanner.vue";

export default {
  name: "LocationForm",
  components: { AlertBanner },
  emits: ["location-created"],
  data() {
    return {
      message: "",
      error: "",
      loading: false,
      form: {
        label: "",
        address: "",
        city: "Sliema",
        country: "Malta",
      },
    };
  },
  methods: {
    async addLocation() {
      try {
        this.message = "";
        this.error = "";
        this.loading = true;

        await this.$store.dispatch("addLocation", {
          ...this.form,
          userId: this.$store.getters.userId,
        });

        this.message = "Location added successfully.";

        this.form.label = "";
        this.form.address = "";
        this.form.city = "Sliema";
        this.form.country = "Malta";

        this.$emit("location-created");
      } catch (error) {
        this.error = error.response?.data?.message || "Could not add location";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.field-label {
  @apply block text-xs font-semibold text-slate-500 mb-1.5 uppercase tracking-wide;
}
.field-input {
  @apply w-full border border-slate-200 rounded-xl px-3.5 py-2.5 text-sm bg-slate-50 text-slate-800 placeholder-slate-400
         focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition;
}
</style>
